import { Box } from "@mui/material";
import { PhoneInputField, Select, TextField } from "components/UI";
import { memo } from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

const StructureDetailProfileSection = memo(
  ({
    register,
    errors,
    structureTypeOptions,
    parentStructureOptions,
    isLoadingStructureTypes,
    isLoadingDenominations,
    isCreatedByUser,
    control
  }) => {
    const { t } = useTranslation();

    return (
      <Box
        sx={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 2 }}
      >
        <TextField
          label={t("denominations.structures.structureName")}
          name="name"
          error={!!errors.name?.message}
          helperText={errors.name?.message}
          register={register}
          isLabelBold={true}
          disabled={!isCreatedByUser}
        />

        <TextField
          label={t("denominations.structures.structureAcronym")}
          name="acronyms"
          error={!!errors.acronyms?.message}
          helperText={errors.acronyms?.message}
          register={register}
          isLabelBold={true}
          disabled={!isCreatedByUser}
        />

        <TextField
          label={t("form.common.pobox")}
          name="p_o_box"
          error={!!errors.p_o_box?.message}
          helperText={errors.p_o_box?.message}
          register={register}
          isLabelBold={true}
          disabled={!isCreatedByUser}
        />

        <TextField
          label={t("form.common.email")}
          name="email"
          error={!!errors.email?.message}
          helperText={errors.email?.message}
          register={register}
          isLabelBold={true}
          disabled={!isCreatedByUser}
        />

        <Controller
          name="phone"
          control={control}
          render={({ field }) => (
            <PhoneInputField
              variant="filled"
              label={t("form.common.phone")}
              error={!!errors.phone?.message}
              helperText={errors.phone?.message}
              disabled={!isCreatedByUser}
              isLabelBold={1}
              {...field}
            />
          )}
        />

        <Select
          isLabelBold={true}
          label={t("denominations.structures.structureType")}
          name="denomination_structure_type_id"
          options={[
            {
              optionLabel: t("denominations.structures.selectStructureType"),
              value: "",
              disabled: true
            },
            ...structureTypeOptions
          ]}
          register={register}
          error={!!errors.denomination_structure_type_id?.message}
          helperText={errors.denomination_structure_type_id?.message}
          disabled={!isCreatedByUser || isLoadingStructureTypes}
        />

        <Select
          isLabelBold={true}
          label={t("denominations.structures.parentStructure")}
          name="parent_id"
          options={[
            {
              optionLabel: t("denominations.structures.selectParentStructure"),
              value: "",
              disabled: true
            },
            ...parentStructureOptions
          ]}
          register={register}
          error={!!errors.parent_id?.message}
          helperText={errors.parent_id?.message}
          disabled={!isCreatedByUser || isLoadingDenominations}
        />
      </Box>
    );
  }
);

StructureDetailProfileSection.displayName = "StructureDetailProfileSection";

export default StructureDetailProfileSection;
